import React from "react";
import { useState, useEffect } from "react";
import { motion, useDragControls } from "framer-motion";
import { Resizable } from "react-resizable";
import { Github, Linkedin } from "react-bootstrap-icons";

// Components
import Magnetic from "../Common/Magnetic/Magnetic";

// SCSS
import "./Resizable.scss";
import "./WindowFrame.scss";

const WindowFrame = ({
  onClose,
  title,
  children,
  setHoveredElement,
  style,
  onPointerDown,
  initialWidth = 600,
  initialHeight = 600,
}) => {
  // isMobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Window Resizing
  const [size, setSize] = useState({
    width: initialWidth,
    height: initialHeight,
  });

  useEffect(() => {
    setSize({ width: initialWidth, height: initialHeight });
  }, [initialWidth, initialHeight]);

  const onResize = (event, { node, size, handle }) => {
    setSize({ width: size.width, height: size.height });
  };

  // Handel
  const [windowState, setWindowState] = useState("normal");

  const handleMaximize = (e) => {
    e.stopPropagation();
    setWindowState(windowState === "maximized" ? "normal" : "maximized");
  };

  const isFull = windowState === "maximized" || isMobile;

  // Window Drag
  const controls = useDragControls();

  return (
    // Frame
    <Resizable
      width={size.width}
      height={size.height}
      onResize={onResize}
      minConstraints={[300, 350]}
      maxConstraints={[1600, 800]}
      handle={
        !isFull ? (
          <span
            className="custom-handle"
            onPointerDown={(e) => e.stopPropagation()}
          />
        ) : null
      }
    >
      <motion.div
        drag={isFull ? false : true}
        dragControls={controls}
        dragListener={false}
        dragMomentum={false}
        initial={{ opacity: 0, scale: 0.5, x: "-50%", y: "-50%" }}
        animate={
          isFull
            ? {
                width: "100vw",
                height: "100vh",
                x: 0,
                y: 0,
                left: 0,
                top: 0,
                borderRadius: 0,
                opacity: 1,
                scale: 1,
              }
            : {
                width: size.width,
                height: size.height,
                x: "-50%",
                y: "-50%",
                borderRadius: "32px",
                opacity: 1,
                scale: 1,
              }
        }
        exit={{ opacity: 0, scale: 0.5, x: "-50%", y: "-50%" }}
        style={{
          ...style,
          width: size.width + "px",
          height: size.height + "px",
          position: "absolute",
          left: "50%",
          top: "50%",
          display: "block",
        }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        onClick={(e) => e.stopPropagation()}
        onPointerDown={onPointerDown}
        className="WindowFrame"
      >
        {/* Header */}
        <div
          className="WindowFrame__Header"
          onPointerDown={(e) => controls.start(e)}
        >
          <ul
            className="WindowFrame__ButtonList"
            onPointerDown={(e) => e.stopPropagation()}
          >
            {/* Red Button */}
            <li className="WindowFrame__ButtonItem">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="button"
                type="button"
                className="WindowFrame__Button WindowFrame__Button-Red"
                onClick={onClose}
              ></Magnetic>
            </li>
            {/* Yellow Button */}
            <li className="WindowFrame__ButtonItem">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="button"
                type="button"
                className="WindowFrame__Button WindowFrame__Button-Yellow"
                onClick={onClose}
              ></Magnetic>
            </li>

            {/* Green Button */}
            <li className="WindowFrame__ButtonItem">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="button"
                type="button"
                className="WindowFrame__Button WindowFrame__Button-Green"
                onClick={handleMaximize}
              ></Magnetic>
            </li>
          </ul>

          <h2 className="WindowFrame__Title">{title}</h2>
        </div>

        {/* Content */}
        <div className="WindowFrame__Content">{children}</div>

        {/* Footer */}
        <div className="WindowFrame__Footer">
          <ul className="WindowFrame__Links">
            <li className="WindowFrame__Link">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="a"
                href="https://www.linkedin.com/in/dkssud-chaeyeon/"
                target="_blank"
                rel="noreferrer"
              >
                <Linkedin />
              </Magnetic>
            </li>
            <li className="WindowFrame__Link">
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="a"
                href="https://github.com/dkssud-dus"
                target="_blank"
                rel="noreferrer"
              >
                <Github />
              </Magnetic>
            </li>
          </ul>
        </div>
      </motion.div>
    </Resizable>
  );
};

export default WindowFrame;
